import React from 'react';
import "./Modalss.css"

const Modal = (prop) => {

  return (
    <div>


        <div className="modal-overlay">



          <div className="modal-content">


  

             <h6 className='modal-warn'> Warning:</h6>
            <p className='modal_msg'>{prop.msg} </p>

             <div className='model-main-content'>

              {
                prop.data.map((e,i)=>{

                 return<div key={i} style={{display:"flex",width:"100%",fontSize:"13px"}}> <div style={{width:"30%"}}> {e.dis_date
                 }</div>
          <div style={{width:"70%", wordWrap:"break-word",paddingLeft:'5px'}}>{e.dis_name}</div>
</div>
                })
              }
             </div>
           

<div className='modal-btn-div'>
  <button className='modal-close-button' onClick={prop.confirm_fn}>Confirm</button>

   <button className='modal-close-button' onClick={prop.cancel_fun}>Cancel</button>
        
       </div>
          </div>

        
        </div>

    </div>
  );
};

export default Modal;









// import React, { useState } from 'react';
// import "./Modal.css"

// const Modal = () => {




  
//   const [isOpen, setIsOpen] = useState(false);
//   const [input1, setInput1] = useState('');
//   const [input2, setInput2] = useState('');
//   const [input3, setInput3] = useState('');
//   const [type, setType] = useState('Text');
//   const [message,setMessage] = useState("")
//   const [buttonarry,setButtonarray]    = useState([])

//   const handleOpenModal = () => {
//     setIsOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsOpen(false);
//     setInput1('');
//     setInput2('');
//     setInput3('');
//   };

//   const handleInputChange = (e) => {
//     const value = e.target.value;
//     const inputname = e.target.name
//     switch (inputname) {
//       case 'type':
//         setType(value);
//         break;
//       case 'Message':
//         setMessage(value)
//         break;
//       case 'input3':
//         setInput3(value);
//         break;
//       default:
//         break;
//     }
//   };

//   return (
//     <div>
//       <button onClick={handleOpenModal}>Open Modal</button>

//       {isOpen && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <h2>Modal Content</h2>

//             <label>
//               User Reply:
//               <input
//                 name ="User_Reply"
//                 type="text"
//                 value={input1}
//                 onChange={ handleInputChange}
//               />
//             </label>

//             <label>
//             <select
//                     name="type"
//                     id="type"
//                     onChange={handleInputChange} >
                       
//                     <option value="Text">Text</option>
//                     <option value="Button">Button</option>
              
//                     <option value="Image">Image</option>
//                     <option value="Video">Video</option>
//                   </select>
//             </label>

          
//             <>
//             {
            
//             type ==="Text"?(
//             <> 
//              <label>
//               Message:
//               <input
//                 type="text"
//                 name ="Message"
//                 value={message}
//                 onChange={handleInputChange}
//               />


//             </label>

//             </>
//             ):""


            





// }
 
//    { type ==="Button"?(
//             <> 
//              <label>
//               Message:
//               <input
//                 type="text"
//                 name ="Message"
//                 value={message}
//                 onChange={handleInputChange}
//               />


//             </label>

//             <label>
//                Button:
//               <input
//                 type="text"
//                 value={input3}
//                 onChange={handleInputChange}
//               />
             
//             </label>
//             </>
//             ):""
//    }
          
//           {


// type ==="Image"?(
//   <> 
//    <label>
//     Caption:
//     <input
//       type="text"
//       value={input2}
//       onChange={handleInputChange}
//     />


//   </label>

//   <label>
//      file:
//     <input
//       type="file"
//       value={input3}
//       onChange={handleInputChange}
//     />
//   </label>
//   </>
//   ):""



//           }





// {


// type ==="Video"?(
//   <> 
//    <label>
//     Caption:
//     <input
//       type="text"
//       value={input2}
//       onChange={handleInputChange}
//     />


//   </label>

//   <label>
//      file:
//     <input
//       type="file"
//       value={input3}
//       onChange={handleInputChange}
//     />
//   </label>
//   </>
//   ):""



//           }



//             </>
           


//             <button onClick={handleCloseModal}>Save</button>

//             <button onClick={handleCloseModal}>Close</button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Modal;
